import { useLazyLoader } from "common/redux/useLazySelector";
import * as MerchantActions from 'features/merchants/merchants.actions';
import { FormField } from "domain/formFieldSetting";
import IsLoaded from "common/isLoaded";

const defaultVal: FormField[] = [];
export default function useEditableContractFields(): IsLoaded<FormField[]> {
    return useLazyLoader(store => store.editableContractFields, MerchantActions.loadEditableContractFields, null, defaultVal);
}